"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _LG = _interopRequireDefault(require("../Icons/Leaf/LG"));
var _MD = _interopRequireDefault(require("../Icons/Leaf/MD"));
var _SM = _interopRequireDefault(require("../Icons/Leaf/SM"));
var _LG2 = _interopRequireDefault(require("../Icons/Star/LG"));
var _MD2 = _interopRequireDefault(require("../Icons/Star/MD"));
var _SM2 = _interopRequireDefault(require("../Icons/Star/SM"));
var _LG3 = _interopRequireDefault(require("../Icons/StarOutlined/LG"));
var _MD3 = _interopRequireDefault(require("../Icons/StarOutlined/MD"));
var _SM3 = _interopRequireDefault(require("../Icons/StarOutlined/SM"));
var _tss = require("../styles/tss");
var _useTheme = require("../styles/useTheme");
var _utilities = require("../utilities");
var _focusVisible = require("../utilities/focusVisible");
var _unstable_useId = _interopRequireDefault(require("../utilities/unstable_useId"));
var _useControlled = _interopRequireDefault(require("../utilities/useControlled"));
var _useForkRef = _interopRequireDefault(require("../utilities/useForkRef"));
const _excluded = ["value"],
  _excluded2 = ["classes", "className", "defaultValue", "disabled", "emptyLabelText", "getLabelText", "IconContainerComponent", "max", "name", "onChange", "onMouseLeave", "onMouseMove", "precision", "readOnly", "size", "variant", "value", "icon"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}
function getDecimalPrecision(num) {
  const decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}
function roundValueToPrecision(value, precision) {
  if (value == null) {
    return value;
  }
  const nearest = Math.round(value / precision) * precision;
  return Number(nearest.toFixed(getDecimalPrecision(precision)));
}
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsRating',
  uniqId: 'oOI5eA'
})((theme, _params, classes) => {
  const {
    colors,
    spacing
  } = theme.busbud;
  return {
    root: {
      display: 'inline-flex',
      position: 'relative',
      lineHeight: 0,
      color: colors.icon.special.opaque,
      cursor: 'pointer',
      WebkitTapHighlightColor: 'transparent',
      [`&.${classes.disabled}`]: {
        opacity: 0.5,
        pointerEvents: 'none'
      }
    },
    sizeSm: {
      [`& > .${classes.starContainer}:not(:last-of-type)`]: {
        marginRight: spacing(-0.25)
      }
    },
    sizeMd: {
      [`& > .${classes.starContainer}:not(:last-of-type)`]: {
        marginRight: spacing(-0.375)
      }
    },
    sizeLg: {
      [`& > .${classes.starContainer}:not(:last-of-type)`]: {
        marginRight: spacing(-0.5)
      }
    },
    readOnly: {
      pointerEvents: 'none'
    },
    disabled: {},
    focusVisible: {},
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    },
    pristine: {
      'input:focus + &': {
        top: 0,
        bottom: 0,
        position: 'absolute',
        width: '100%'
      }
    },
    starContainer: {
      cursor: 'inherit'
    },
    icon: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      pointerEvents: 'none'
    },
    iconEmpty: {
      color: colors.background.tertiary.transparent
    },
    iconLeafFilled: {
      color: colors.icon.positive.opaque
    },
    iconFilled: {},
    iconHover: {},
    iconFocus: {},
    iconActive: {
      transform: 'scale(1.2)'
    },
    decimal: {
      position: 'relative'
    },
    hiddenStar: {
      overflow: 'hidden',
      zIndex: 1,
      position: 'absolute'
    },
    noWidthStar: {
      width: 0
    },
    halfWidthStar: {
      width: '50%'
    }
  };
});
function IconContainer(props) {
  const {
      value
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/React.createElement("span", other);
}

// Consumer should provide getLabelText prop when page language is not English
function defaultLabelText(value) {
  return `${value} Star${value !== 1 ? 's' : ''}`;
}
function getSizeClassKey(size) {
  return `size${(0, _utilities.capitalizeFirstWord)(size)}`;
}

/**
 * **❗️ DEPRECATED**: Use the `Rating` from pubweb instead.
 *
 * Ratings provide insight regarding others’ opinions and experiences with a product.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-rating--page)
 *
 * @deprecated
 */
const Rating = /*#__PURE__*/React.forwardRef(function Rating(props, ref) {
  const {
      classes: classesOverrides,
      className,
      defaultValue = null,
      disabled = false,
      emptyLabelText = 'Empty',
      getLabelText = defaultLabelText,
      IconContainerComponent = IconContainer,
      max = 5,
      name: nameProp,
      onChange,
      onMouseLeave,
      onMouseMove,
      precision = 1,
      readOnly = false,
      size = 'md',
      variant = 'filled',
      value: valueProp,
      icon: iconVariant = 'star'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded2);
  const {
    classes,
    cx
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  let icon;
  let iconEmpty;
  const setIconEmpty = iconComponent => variant === 'outlined' ? iconComponent : icon;

  // set either leaf or star based on icon prop and size prop
  // TODO: fix outlined variant of leaf
  if (iconVariant === 'leaf') {
    if (size === 'sm') {
      icon = /*#__PURE__*/React.createElement(_SM.default, null);
      iconEmpty = setIconEmpty(/*#__PURE__*/React.createElement(_SM.default, null));
    } else if (size === 'lg') {
      icon = /*#__PURE__*/React.createElement(_LG.default, null);
      iconEmpty = setIconEmpty(/*#__PURE__*/React.createElement(_LG.default, null));
    } else {
      icon = /*#__PURE__*/React.createElement(_MD.default, null);
      iconEmpty = setIconEmpty(/*#__PURE__*/React.createElement(_MD.default, null));
    }
  } else if (size === 'sm') {
    icon = /*#__PURE__*/React.createElement(_SM2.default, null);
    iconEmpty = setIconEmpty(/*#__PURE__*/React.createElement(_SM3.default, null));
  } else if (size === 'lg') {
    icon = /*#__PURE__*/React.createElement(_LG2.default, null);
    iconEmpty = setIconEmpty(/*#__PURE__*/React.createElement(_LG3.default, null));
  } else {
    icon = /*#__PURE__*/React.createElement(_MD2.default, null);
    iconEmpty = setIconEmpty(/*#__PURE__*/React.createElement(_MD3.default, null));
  }
  const name = (0, _unstable_useId.default)(nameProp);
  const [valueDerived, setValueState] = (0, _useControlled.default)({
    controlled: valueProp,
    default: defaultValue,
    name: 'Rating'
  });
  if (precision < 0.1) {
    throw new Error(['Design System: The prop `precision` should be above 0.1.', 'A value below this limit has an imperceptible impact.'].join('\n'));
  }
  const valueRounded = roundValueToPrecision(valueDerived, precision);
  const theme = (0, _useTheme.useTheme)();
  const [{
    hover,
    focus
  }, setState] = React.useState({
    hover: -1,
    focus: -1
  });
  let value = valueRounded;
  if (hover !== -1) {
    value = hover;
  }
  if (focus !== -1) {
    value = focus;
  }
  const {
    isFocusVisible,
    onBlurVisible,
    ref: focusVisibleRef
  } = (0, _focusVisible.useIsFocusVisible)();
  const [focusVisible, setFocusVisible] = React.useState(false);
  const rootRef = React.useRef();
  const handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, rootRef);
  const handleRef = (0, _useForkRef.default)(handleFocusRef, ref);
  const handleMouseMove = event => {
    if (onMouseMove) {
      onMouseMove(event);
    }
    const rootNode = rootRef.current;
    const {
      right,
      left
    } = rootNode && rootNode.getBoundingClientRect();
    const {
      width
    } = rootNode && rootNode.firstChild.getBoundingClientRect();
    let percent;
    if (theme.direction === 'rtl') {
      percent = (right - event.clientX) / (width * max);
    } else {
      percent = (event.clientX - left) / (width * max);
    }
    let newHover = roundValueToPrecision(max * percent + precision / 2, precision);
    newHover = clamp(newHover, precision, max);
    setState(prev => prev.hover === newHover && prev.focus === newHover ? prev : {
      hover: newHover,
      focus: newHover
    });
    setFocusVisible(false);
  };
  const handleMouseLeave = event => {
    if (onMouseLeave) {
      onMouseLeave(event);
    }
    const newHover = -1;
    setState({
      hover: newHover,
      focus: newHover
    });
  };
  const handleChange = event => {
    const newValue = parseFloat(event.target.value);
    setValueState(newValue);
    if (onChange) {
      onChange(event, newValue);
    }
  };
  const handleClear = event => {
    // Ignore keyboard events
    // https://github.com/facebook/react/issues/7407
    if (event.clientX === 0 && event.clientY === 0) {
      return;
    }
    setState({
      hover: -1,
      focus: -1
    });
    setValueState(null);
    if (onChange && parseFloat(event.target.value) === valueRounded) {
      onChange(event, null);
    }
  };
  const handleFocus = event => {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
    const newFocus = parseFloat(event.target.value);
    setState(prev => ({
      hover: prev.hover,
      focus: newFocus
    }));
  };
  const handleBlur = () => {
    if (hover !== -1) {
      return;
    }
    if (focusVisible !== false) {
      setFocusVisible(false);
      onBlurVisible();
    }
    const newFocus = -1;
    setState(prev => ({
      hover: prev.hover,
      focus: newFocus
    }));
  };
  const item = (state, labelProps) => {
    const id = `${name}-${String(state.value).replace('.', '-')}`;
    const container = /*#__PURE__*/React.createElement(IconContainerComponent, {
      value: state.value,
      className: cx(classes.icon, {
        [classes.iconEmpty]: !state.filled,
        [classes.iconLeafFilled]: iconVariant === 'leaf' && state.filled,
        [classes.iconFilled]: iconVariant === 'star' && state.filled,
        [classes.iconHover]: state.hover,
        [classes.iconFocus]: state.focus,
        [classes.iconActive]: state.active
      })
    }, state.filled ? icon : iconEmpty);
    if (!readOnly && !nameProp) {
      throw new Error(['Design System: The prop `name` is required (when `readOnly` is false).', 'Additionally, the input name should be unique within the parent form.'].join('\n'));
    }
    if (readOnly) {
      return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
        key: state.value
      }, labelProps, {
        className: cx(classes.starContainer, labelProps?.className)
      }), container);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: state.value
    }, /*#__PURE__*/React.createElement("label", (0, _extends2.default)({
      className: classes.starContainer,
      htmlFor: id
    }, labelProps), container, /*#__PURE__*/React.createElement("span", {
      className: classes.visuallyHidden
    }, getLabelText(state.value))), /*#__PURE__*/React.createElement("input", {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onClick: handleClear,
      disabled: disabled,
      value: state.value,
      id: id,
      type: "radio",
      name: name,
      checked: state.checked,
      className: classes.visuallyHidden
    }));
  };
  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
    ref: handleRef,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    className: cx(classes.root, classes[getSizeClassKey(size)], {
      [classes.disabled]: disabled,
      [classes.focusVisible]: focusVisible,
      [classes.readOnly]: readOnly
    }, className),
    role: readOnly ? 'img' : undefined,
    "aria-label": readOnly ? getLabelText(value) : undefined
  }, other), range(1, max).map(itemValue => {
    if (precision < 1) {
      const items = range(0, 1 / precision - 1);
      return /*#__PURE__*/React.createElement("span", {
        key: itemValue,
        className: cx(classes.decimal, {
          [classes.iconActive]: itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1)
        })
      }, items.map(indexDecimal => {
        const itemDecimalValue = roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
        const is_last_item = items.length - 1 === indexDecimal;

        /*
         * Style is repeated for each stars; so we want to opimize for the most common case (precision = 0.5)
         * to ensure that in this case we use classes instead to avoid useless duplication
         */
        let star_classes;
        let style_width;
        if (is_last_item) {
          style_width = undefined;
          star_classes = undefined;
        } else if (itemDecimalValue === value) {
          const star_width = (indexDecimal + 1) * precision * 100;
          if (star_width === 50) {
            star_classes = classes.halfWidthStar;
          } else {
            style_width = `${star_width}%`;
          }
        } else {
          style_width = undefined;
          star_classes = classes.noWidthStar;
        }
        return item({
          value: itemDecimalValue,
          filled: itemDecimalValue <= value,
          hover: itemDecimalValue <= hover,
          focus: itemDecimalValue <= focus,
          checked: itemDecimalValue === valueRounded
        }, {
          className: cx(!is_last_item ? classes.hiddenStar : undefined, star_classes),
          style: style_width ? {
            width: style_width
          } : {}
        });
      }));
    }
    return item({
      value: itemValue,
      active: itemValue === value && (hover !== -1 || focus !== -1),
      filled: itemValue <= value,
      hover: itemValue <= hover,
      focus: itemValue <= focus,
      checked: itemValue === valueRounded
    });
  }), !readOnly && !disabled && valueRounded == null && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    value: "",
    id: `${name}-empty`,
    type: "radio",
    name: name,
    defaultChecked: true,
    className: classes.visuallyHidden
  }), /*#__PURE__*/React.createElement("label", {
    className: classes.pristine,
    htmlFor: `${name}-empty`
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.visuallyHidden
  }, emptyLabelText))));
});
function range(start, end) {
  return Array.from({
    length: end - start + 1
  }, (_, i) => i + start);
}
var _default = exports.default = Rating;